module.exports = __webpack_public_path__ + "static/media/9a.8aa87f98.jpg";